import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Creditors from '../views/Creditors.vue'
import AssignedCreditors from "../views/AssignedCreditors.vue";
import Negotiators from '../views/Negotiators.vue'
import Debtors from '../views/Debtors.vue';
import Administration from '../views/Administration.vue';
import Payments from '../views/Payments.vue';
import CreditorView from '../views/CreditorView.vue'
import DebtorView from '../views/DebtorView.vue'
import Warrants from "../views/Warrants.vue"
import WarrantView from '../views/WarrantView.vue'
import Invoices from '../views/Invoices.vue'
import InvoiceView from '../views/InvoiceView.vue'
import NewGenericInvoice from '../views/NewGenericInvoice.vue'
import AddInvoicesPayments from '../views/AddInvoicesPayments.vue'
import AddWarrantsPayments from '../views/AddWarrantsPayments.vue'
import UnreadNotes from '../views/UnreadNotes.vue'
import MailsToSend from '../views/MailsToSend.vue'
import Prospects from '../views/Prospects.vue'
import AccountStatements from '../views/AccountStatements.vue'
import AccountStatementView from '../views/AccountStatementView'
import ChartAccounts from '../views/ChartAccounts.vue'
import Translations from '../views/Translations.vue'
import PurchaseOrder from '../views/PurchaseOrder.vue'
import PurchaseOrderHistory from "../views/PurchaseOrderHistory.vue";
import WarrantOpen from '../views/WarrantOpen.vue'
import Settlement from '../views/Settlement.vue'
import Settlements from "../views/Settlements.vue";
import NewSettlement from '../views/NewSettlement.vue'
import Sellers from '../views/Sellers.vue'
import Localities from '../views/Localities.vue'
import CourrierTypes from '../views/CourrierTypes.vue'
import FrontHistory from '../views/FrontHistory.vue'
import NewslettersList from '../views/NewslettersList.vue'
import Newsletters from '../views/Newsletters.vue'
import NewslettersNew from '../views/NewslettersNew.vue'
import NewslettersGroups from '../views/NewslettersGroups.vue'
import NewslettersGroupUsers from '../views/NewslettersGroupUsers.vue'
import ManageWarrantsWithoutDebtor from '../views/ManageWarrantsWithoutDebtor.vue'
import ManageWait from '../views/ManageWait.vue'
import ManageNoSMS from '../views/ManageNoSMS.vue'
import ManageSMS from '../views/ManageSMS.vue'
import ManageSeuil from '../views/ManageSeuil.vue'
import ManageAssigned from '../views/ManageAssigned.vue'
import ManageCommission from '../views/ManageCommission.vue'
import ManageAcks from '../views/ManageAcks.vue'
import ManageAssignations from '../views/ManageAssignations.vue'
import ManageTribunal from '../views/ManageTribunal.vue'
import ManageClose from '../views/ManageClose.vue'
import ManageCanceled from '../views/ManageCanceled.vue'
import ManageUnused from '../views/ManageUnused.vue'
import ManageCreditorsWithoutWarrants from '../views/ManageCreditorsWithoutWarrants.vue'
import ManageCreditorsReminders from "../views/ManageCreditorsReminders.vue";
import ManageCreditorsToCheck from "../views/ManageCreditorsToCheck.vue";
import ManageCreditorsSendLogin from "../views/ManageCreditorsSendLogin.vue";
import ManageNewslettersSettings from '../views/ManageNewslettersSettings.vue'
import ManageWarrantsWithoutSettlements from '../views/ManageWarrantsWithoutSettlements.vue'
import ManageWarrantsToCheck from '../views/ManageWarrantsToCheck.vue'
import ManageDebtorsToCheck from '../views/ManageDebtorsToCheck.vue'
import ManageSettlementsInDefault from '../views/ManageSettlementsInDefault.vue'
import ManageSettlementsInDefaultEmail from '../views/ManageSettlementsInDefaultEmail.vue'
import ManageWarrants3Reminders from '../views/ManageWarrants3Reminders.vue'
import ManageWarrantsStopped from '../views/ManageWarrantsStopped.vue'
import ManageNegoReminders from '../views/ManageNegoReminders.vue'
import ManageLawyerReminders from '../views/ManageLawyerReminders.vue'
import ManageReminders from '../views/ManageReminders.vue'
import ManageAccountStatements from '../views/ManageAccountStatements.vue'
import PreviewAccountStatements from '../views/PreviewAccountStatements.vue'
import InvoicesCommission from '../views/InvoicesCommission.vue'
import CommissionsNego from '../views/CommissionsNego.vue'
import Parameters from '../views/Parameters.vue'
import Archives from '../views/Archives.vue'
import ImportCodas from '../views/ImportCodas.vue'
import Live from '../views/Live.vue'
import Agenda from "../views/Agenda.vue";
import RoutesList from '../views/RoutesList.vue'
import MigrateWarrants from "../views/MigrateWarrants.vue";
import FusionDebtors from "../views/FusionDebtors.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/routes-list",
    name: "routesList",
    component: RoutesList,
    props: true,
  },
  {
    path: "/commissions-nego",
    name: "commissionsNego",
    component: CommissionsNego,
  },
  {
    path: "/front-history",
    name: "frontHistory",
    component: FrontHistory,
  },
  {
    path: "/sellers",
    name: "sellers",
    component: Sellers,
  },
  {
    path: "/prospects",
    name: "prospects",
    component: Prospects,
  },
  {
    path: "/purchase-order",
    name: "purchaseOrder",
    component: PurchaseOrder,
  },
  {
    path: "/purchase-order-history",
    name: "purchaseOrderHistory",
    component: PurchaseOrderHistory,
  },
  {
    path: "/creditors",
    name: "creditors",
    component: Creditors,
  },
  {
    path: "/assigned-creditors",
    name: "assignedCreditors",
    component: AssignedCreditors,
  },
  {
    path: "/migrate-warrants",
    name: "migrateWarrants",
    component: MigrateWarrants,
  },
  {
    path: "/fusion-debtors",
    name: "fusionDebtors",
    component: FusionDebtors,
  },
  {
    path: "/creditors/:search",
    name: "creditorsSearch",
    component: Creditors,
  },
  {
    path: "/creditor/view/:id",
    name: "creditorView",
    component: CreditorView,
    props: true,
  },
  {
    path: "/creditor/new",
    name: "creditorNew",
    component: CreditorView,
    props: { _new: true, edit: true },
  },
  {
    path: "/warrant/open/:id",
    name: "warrantOpen",
    component: WarrantOpen,
    props: true,
  },
  {
    path: "/creditor/edit/:id",
    name: "creditorEdit",
    component: CreditorView,
    props: true,
  },
  {
    path: "/debtors",
    name: "debtors",
    component: Debtors,
  },
  {
    path: "/debtor/view/:id",
    name: "debtorView",
    component: DebtorView,
    props: { edit: false },
  },
  {
    path: "/debtor/edit/:id",
    name: "debtorEdit",
    component: DebtorView,
    props: { edit: true },
  },
  {
    path: "/debtor/new",
    name: "debtorNew",
    component: DebtorView,
    props: { _new: true, edit: true },
  },
  {
    path: "/debtors/:search",
    name: "debtorsSearch",
    component: Debtors,
  },
  {
    path: "/payments",
    name: "payments",
    component: Payments,
  },
  {
    path: "/payments/:search",
    name: "paymentsSearch",
    component: Payments,
  },
  {
    path: "/invoice/view/:id",
    name: "invoiceView",
    component: InvoiceView,
  },
  {
    path: "/invoice/new-generic",
    name: "newGenericInvoice",
    component: NewGenericInvoice,
  },
  {
    path: "/invoices",
    name: "invoices",
    component: Invoices,
  },
  {
    path: "/invoices-commission/creditor/:id",
    name: "invoicesCommission",
    component: InvoicesCommission,
  },
  {
    path: "/invoices-commissions",
    name: "invoicesCommissions",
    component: InvoicesCommission,
  },
  {
    path: "/settlement/:id",
    name: "settlement",
    component: Settlement,
    props: true,
  },
  {
    path: "/settlements/:id",
    name: "settlements",
    component: Settlements,
    props: true,
  },
  {
    path: "/new-settlement/:id",
    name: "newSettlement",
    component: NewSettlement,
    props: true,
  },
  {
    path: "/warrant/view/:id",
    name: "warrantView",
    component: WarrantView,
    props: true,
  },
  {
    path: "/warrant/edit/:id",
    name: "warrantEdit",
    component: WarrantView,
    props: { edit: true },
  },
  {
    path: "/invoices/:search",
    name: "invoicesSearch",
    component: Invoices,
  },
  {
    path: "/warrants/",
    name: "warrants",
    component: Warrants,
  },
  {
    path: "/newsletters/",
    name: "newsletters",
    component: Newsletters,
  },
  {
    path: "/newsletters/new",
    name: "newslettersNew",
    component: NewslettersNew,
  },
  {
    path: "/newsletters/list",
    name: "newslettersList",
    component: NewslettersList,
  },
  {
    path: "/newsletters/groups",
    name: "newslettersGroups",
    component: NewslettersGroups,
  },
  {
    path: "/newsletters/group/:id",
    name: "newslettersGroupUsers",
    component: NewslettersGroupUsers,
    props: true,
  },
  {
    path: "/manage-acks/",
    name: "manageAcks",
    component: ManageAcks,
  },
  {
    path: "/manage-commission/",
    name: "manageCommission",
    component: ManageCommission,
  },
  {
    path: "/manage-wait/",
    name: "manageWait",
    component: ManageWait,
  },
  {
    path: "/manage-sms/",
    name: "manageSMS",
    component: ManageSMS,
  },
  {
    path: "/manage-no-sms/",
    name: "manageNoSMS",
    component: ManageNoSMS,
  },
  {
    path: "/manage-trigger/",
    name: "manageSeuil",
    component: ManageSeuil,
  },
  {
    path: "/manage-newsletters-settings/",
    name: "manageNewslettersSettings",
    component: ManageNewslettersSettings,
  },
  {
    path: "/manage-assigned/",
    name: "manageAssigned",
    component: ManageAssigned,
  },
  {
    path: "/manage-assignations/",
    name: "manageAssignations",
    component: ManageAssignations,
  },
  {
    path: "/manage-tribunal/",
    name: "manageTribunal",
    component: ManageTribunal,
  },
  {
    path: "/manage-close/",
    name: "manageClose",
    component: ManageClose,
  },
  {
    path: "/manage-canceled/",
    name: "manageCanceled",
    component: ManageCanceled,
  },
  {
    path: "/manage-creditors-without-warrants/",
    name: "manageCreditorsWithoutWarrants",
    component: ManageCreditorsWithoutWarrants,
  },
  {
    path: "/manage-creditors-reminders/",
    name: "manageCreditorsReminders",
    component: ManageCreditorsReminders,
  },
  {
    path: "/manage-creditors-to-check/",
    name: "manageCreditorsToCheck",
    component: ManageCreditorsToCheck,
  },
  {
    path: "/manage-creditors-send-login/",
    name: "manageCreditorsSendLogin",
    component: ManageCreditorsSendLogin,
  },
  {
    path: "/manage-warrants-without-debtor/",
    name: "manageWarrantsWithoutDebtor",
    component: ManageWarrantsWithoutDebtor,
  },
  {
    path: "/manage-warrants-without-settlements/",
    name: "manageWarrantsWithoutSettlements",
    component: ManageWarrantsWithoutSettlements,
  },
  {
    path: "/manage-warrants-to-check/",
    name: "manageWarrantsToCheck",
    component: ManageWarrantsToCheck,
  },
  {
    path: "/manage-debtors-to-check/",
    name: "manageDebtorsToCheck",
    component: ManageDebtorsToCheck,
  },
  {
    path: "/manage-settlements-in-default/",
    name: "manageSettlementsInDefault",
    component: ManageSettlementsInDefault,
  },
  {
    path: "/manage-settlements-in-default-email/",
    name: "manageSettlementsInDefaultEmail",
    component: ManageSettlementsInDefaultEmail,
  },
  {
    path: "/manage-warrants-3-reminders/",
    name: "manageWarrants3Reminders",
    component: ManageWarrants3Reminders,
  },
  {
    path: "/manage-warrants-stopped/",
    name: "manageWarrantsStopped",
    component: ManageWarrantsStopped,
  },
  {
    path: "/manage-nego-reminders/",
    name: "manageNegoReminders",
    component: ManageNegoReminders,
  },
  {
    path: "/manage-lawyer-reminders/",
    name: "manageLawyerReminders",
    component: ManageLawyerReminders,
  },
  {
    path: "/manage-reminders/:nego",
    name: "manageReminders",
    component: ManageReminders,
    props: true,
  },
  {
    path: "/manage-unused/",
    name: "manageUnused",
    component: ManageUnused,
  },
  {
    path: "/manage-account-statements/",
    name: "manageAccountStatements",
    component: ManageAccountStatements,
    props: true,
  },
  {
    path: "/preview-account-statements/",
    name: "previewAccountStatements",
    component: PreviewAccountStatements,
    props: true,
  },
  {
    path: "/warrants/:search",
    name: "warrantsSearch",
    component: Warrants,
  },
  {
    path: "/account-statements",
    name: "account-statements",
    component: AccountStatements,
  },
  {
    path: "/account-statement/view/:id",
    name: "accountStatementView",
    component: AccountStatementView,
  },
  {
    path: "/chart-accounts",
    name: "chartAccounts",
    component: ChartAccounts,
  },
  {
    path: "/add-invoices-payments",
    name: "addInvoicesPayments",
    component: AddInvoicesPayments,
  },
  {
    path: "/add-invoice-payment/:invoice_id",
    name: "addInvoicePayments",
    component: AddInvoicesPayments,
    props: true,
  },
  {
    path: "/add-warrants-payments",
    name: "addWarrantsPayments",
    component: AddWarrantsPayments,
  },
  {
    path: "/unread-notes",
    name: "unreadNotes",
    component: UnreadNotes,
  },
  {
    path: "/mails-to-send",
    name: "mailsToSend",
    component: MailsToSend,
  },
  {
    path: "/courriers-type",
    name: "courrierTypes",
    component: CourrierTypes,
  },
  {
    path: "/administration",
    name: "administration",
    component: Administration,
  },
  {
    path: "/live",
    name: "live",
    component: Live,
  },
  {
    path: "/agenda",
    name: "agenda",
    component: Agenda,
  },
  {
    path: "/administration/negotiators",
    name: "negotiators",
    component: Negotiators,
  },
  {
    path: "/administration/localities",
    name: "localities",
    component: Localities,
  },
  {
    path: "/administration/translations",
    name: "translations",
    component: Translations,
  },
  {
    path: "/administration/parameters",
    name: "parameters",
    component: Parameters,
  },
  {
    path: "/administration/archives",
    name: "archives",
    component: Archives,
  },
  {
    path: "/administration/import-codas",
    name: "import-codas",
    component: ImportCodas,
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
